// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__qg3h6 {
  background: white;
  border-radius: 5px;
  margin: 0 1rem;
  max-height: 83vh;
  padding: 1rem;
}

.styles_contentTab__e6vY2 {
  margin-top: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Relatorios/styles.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".container {\n  background: white;\n  border-radius: 5px;\n  margin: 0 1rem;\n  max-height: 83vh;\n  padding: 1rem;\n}\n\n.contentTab {\n  margin-top: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__qg3h6`,
	"contentTab": `styles_contentTab__e6vY2`
};
export default ___CSS_LOADER_EXPORT___;
